<template>
  <div>
    <v-sheet elevation="1" class="mb-2 px-4 d-flex align-center">
      <v-btn color="primary" class="mr-2" outlined @click="getResult" small>
        <v-icon class="mr-1" small>mdi-check</v-icon> Применить</v-btn
      >

      <v-btn color="error" class="mr-2" small :disabled="true">
        <v-icon class="mr-1" small>mdi-delete</v-icon> Удалить</v-btn
      >
      <v-btn color="success" class="mr-2" small :disabled="true">
        <v-icon class="mr-1" small>mdi-download</v-icon> Скачать</v-btn
      >
      <v-menu
        v-model="showColorsPallete"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            :disabled="!colorPalette"
            light
            small
            outlined
            v-bind="attrs"
            v-on="on"
          >
            <v-icon class="mr-2">mdi-palette</v-icon> Цвет фона
          </v-btn>
        </template>

        <v-card class="pa-1">
          <v-card-title>Цвет фона</v-card-title>
          <v-divider class="mb-2"></v-divider>

          <div class="colors-row">
            <div
              v-for="(color, i) in colorPalette"
              :key="i"
              :style="`backgroundColor: rgb(${color.join(',')})`"
              class="color-button"
              @click="paletteColorClickHandler(color)"
            ></div>
          </div>

          <v-text-field
            placeholder="RGB"
            class="px-5"
            v-model="selectedBackgroundColor"
          ></v-text-field>
        </v-card>
      </v-menu>

      <v-spacer></v-spacer>
      <v-checkbox
        v-model="showMask"
        :disabled="!tableConfig.showMask"
        label="Показывать маску"
        class="mr-4"
      ></v-checkbox>
    </v-sheet>

    <v-sheet elevation="2" class="pb-10 edit-dialog__image-clipper">
      <div style="width: 50%">
        <clipper-fixed
          name="clipper"
          ref="clipper"
          class="clipper"
          cross-origin="anonymous"
          border-color="green"
          :bg-color="selectedBackgroundColor || 'white'"
          :src="imageLink"
          :grid="true"
          :area="areaScale"
          :ratio="tableConfig.imageRatio"
          @load="imagePastedHandler"
          @click="clipperClickHandler"
        ></clipper-fixed>
      </div>

      <div class="image-clipper__mask-wrapper">
        <img
          v-if="tableConfig.showMask"
          :src="maskLink"
          style="z-index: 3; position: relative"
          :style="{ visibility: showMask ? 'visible' : 'hidden' }"
        />
        <div
          v-if="tableConfig.showMask"
          :style="{
            background: 'url(\'' + result + '\')',
          }"
          :class="{
            'image-preview-img__no-mask': !tableConfig.showMask,
            'image-preview-img__mask': tableConfig.showMask,
          }"
        ></div>
        <img v-else :src="result" class="image-preview-img__no-mask" />
      </div>
    </v-sheet>
    <div>
      {{ pixel || " " }}
    </div>
  </div>
</template>

<script>
import { clipperFixed } from "vuejs-clipper";
import { DIALOG_TYPES } from "@/constants/common";
import { v4 as uuid } from "uuid";
import { mapState } from "vuex";
import ColorThief from "colorthief";

export default {
  components: {
    clipperFixed,
  },

  props: {
    names: Array || String,
    prefixer: Function,
    pastedImageData: String,
    id: [Number, Object, undefined],
    type: String,
    tableConfig: Object,
  },

  data() {
    return {
      noImageSlot: `${this.$store.state.ASSETS_ENDPOINT_URL}/common/placeholder.jpg`,
      maskLink: `${this.$store.state.ASSETS_ENDPOINT_URL}/masks/mask.png`,
      result: "",
      pixel: "",
      showMask: this.tableConfig.showMask,
      updateMask: false,
      colorPalette: null,
      showColorsPallete: false,
      selectedBackgroundColor: null,
    };
  },

  computed: {
    ...mapState({
      endpointUrl: (s) => s.ASSETS_ENDPOINT_URL,
      entity: (s) => s.tables.tableEntityType,
    }),

    imageLink() {
      if (this.pastedImageData) return this.pastedImageData;
      if (this.type === DIALOG_TYPES.EDIT)
        return `${this.$store.state.ASSETS_ENDPOINT_URL}/${this.entity}/${this.id}.jpg`;
      return this.noImageSlot;
    },

    areaScale() {
      if (
        this.type === DIALOG_TYPES.EDIT &&
        this.imageLink !== this.noImageSlot
      )
        return 100;

      return 70;
    },
  },

  mounted() {
    const img = document.querySelector(".vuejs-clipper-fixed__img");
    img.addEventListener("click", () => {
      this.clipperClickHandler();
    });
  },

  methods: {
    clipperClickHandler() {
      navigator.clipboard.readText().then((clipText) => {
        if (clipText.startsWith("rgb")) {
          let str = clipText.replace(/[^\d,]+/g, "");
          let color = str.split(",");
          this.colorPalette.splice(this.colorPalette.length, 0, color);
          this.selectedBackgroundColor = `rgb(${str})`;
        }
      });
    },

    paletteColorClickHandler(rgb) {
      this.selectedBackgroundColor = `rgb(${rgb.join(",")})`;
    },

    imagePastedHandler() {
      const colorThief = new ColorThief();
      const img = document.querySelector(".vuejs-clipper-fixed__img");
      const palette = colorThief.getPalette(img, 50);

      this.colorPalette = palette;
    },

    getResult() {
      const canvas = this.$refs.clipper.clip({ wPixel: 550 });

      this.pixel = `${canvas.width} x ${canvas.height}`;
      this.result = canvas.toDataURL("image/jpg");
      this.applyImageFile();
    },

    async applyImageFile() {
      let fileBase64 = await fetch(this.result);
      let blob = await fileBase64.blob();
      let fileName = [uuid(), "jpg"].join(".");
      let packedFile = new File([blob], fileName, { type: "image/jpg" });

      this.$emit("applyImage", packedFile);
    },
  },
};
</script>

<style>
.edit-dialog__image-clipper {
  display: flex;
  height: auto;
  align-items: center;
  justify-content: space-evenly;
}

.image-clipper__mask-wrapper {
  align-self: center;
  position: relative;
}

.image-preview-img__mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-size: cover !important;
  background-repeat: no-repeat;
}

.image-preview-img__no-mask {
  position: relative;
  padding: 10px;
  top: 0px;
  left: 0px;
  z-index: 2;
  width: 300px;
}

.colors-row {
  display: flex;
  max-width: 300px;
  flex-wrap: wrap;
}

.color-button {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 5px;
  cursor: pointer;
  transition: 500ms all;
}

.color-button:hover {
  border: 1px solid rgb(148, 148, 148);
}
</style>
